import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { CounterpartiesTable } from "@/features/counterparties/counterparties-table";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_settings/einstellungen/kreditoren",
)({
  component: CreditorsPage,
});

function CreditorsPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full w-full">
      <div className="font-bold text-xl mb-5">{t("creditors.link")}</div>
      <div className="flex-1">
        <CounterpartiesTable tableName="creditors" type="creditor" />
      </div>
    </div>
  );
}
